// extracted by mini-css-extract-plugin
export default {"reviewContainer":"Review_reviewContainer__ttZoM","review":"Review_review__x-GcS","reviewTitle":"Review_reviewTitle__39Mxa","reviewText":"Review_reviewText__Fv94H"};